export enum UserRole {
	SUPER_ADMIN = 'super_admin',
	PLATFORM_ADMIN = 'platform_admin',
	CLIENT_USER = 'client_user',
}

export interface User {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	role: UserRole;
	clientId?: string;
	clientName?: string;
}

export interface LoginResponse {
	success: boolean;
	user: User;
	tokens: {
		accessToken: string;
		refreshToken: string;
		expiresIn: number;
	};
}
